import { ResourceKey, ResourceLanguage } from 'i18next';

export const LANGUAGES = ['en', 'pl', 'no', 'es'] as const;

export type LanguageKey = (typeof LANGUAGES)[number];

export type LanguagesResources = Record<LanguageKey, ResourceKey>;
export type LanguagesResourcesWithNamespace = Record<LanguageKey, ResourceLanguage>;
